export const ClassroomSettingsActionTypes = {
    OPEN_CLASSROOM_SETTINGS_PAGE: 'OPEN_CLASSROOM_SETTINGS_PAGE',
    CLOSE_CLASSROOM_SETTINGS_PAGE: 'CLOSE_CLASSROOM_SETTINGS_PAGE',
};